import { GastoResponse } from "../../../shared/response/proyectos/ProyectoResponse";
import { GastoSavePayload } from "../../../shared/services/api/payload/proyectos/GastoSavePayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { GastoService } from "./GastoService";

/**
 * Adaptador para registrar un gasto con `BaseSmallModalFormComponent`. Delega en `GastoService`
 * (gRPC `GuardarGasto`). Los gastos viven en el detalle del proyecto,
 * no en un listado propio, así que no alimentan ninguna caché.
 */
export class GastoSaveService extends ServiceSaveBase<GastoResponse, GastoSavePayload> {
  /** Registra o edita el gasto: delega en `GastoService.save` (gRPC `GuardarGasto`). */
  protected sendSave(payload: GastoSavePayload): Promise<GastoResponse> {
    return GastoService.instance.save(payload.proyectoId, payload.itemId, {
      id: payload.id ?? undefined,
      fecha: payload.fecha,
      cantidadReal: payload.cantidadReal,
      precioUnitarioReal: payload.precioUnitarioReal,
      proveedor: payload.proveedor,
      observaciones: payload.observaciones,
    });
  }
}
